export enum AvailableCarriers {
  YUNO = 'yuno',
  IUGU = 'iugu',
  MULTI = 'multi',
}
